<template>
    <div class="wizardStep" :class="{'active': combo.isActive}">
        <div class="title-container" @click="toggleHideGroup">
            <div class="left-part-title">
                <span class="circle" :class="{'disabledCircle' : disabledTitle}" v-text="getGroupNumber()"></span>
                <h2 style="display:inline-block;" :class="{'disabledTitle' : disabledTitle}" v-text="getProductLanguage(combo, 'productGroupName')"></h2>
                <CircleButton v-if="showChangeMutexButton()" :big="true" :icon="change_white" @circleBtnClick="openSelectMutexModal()"></CircleButton>
            </div>
            <div class="count" :class="{'disabledTitle' : disabledTitle}" v-text="buildText()"></div>
        </div>

        <div v-if="combo.groupImage" class="img-container">
            <img :src="combo.groupImage">
        </div>

        <div class="container-input-selected" :class="{'list': itemsList}">
            <div v-for="(productcombo, keyproductcombo) in this.comboOption" :key="keyproductcombo" v-show="productcombo.choosen" class="card-combo">
                <div v-if="productcombo.choosen" class="combo-selected">
                    <div class="selected-products">
                        <span class="customize-combo">{{ getString('personalize_seu_combo') }}</span>
                        <div class="combo-list">
                            <span class="combo-itens" v-for="(item, keyChoosen) in getArrayFromChoosen(productcombo.choosen)" :key="keyChoosen" v-text="(item.quantity ? item.quantity + 'x ' : '') + getProductLanguage(item, 'subItemName')"></span>
                            <div class="edit-button-combo" :class="{'big-mode': iconesGrandes, 'androidMode': isAndroidMode()}">
                                <CircleButton class="edit_button" :big="iconesGrandes" :icon="edit_white" @circleBtnClick="editCombo(keyproductcombo)"></CircleButton>
                                <CircleButton v-if="productcombo.subItemMandatory !== 'S'" :big="iconesGrandes" :icon="delete_white" @circleBtnClick="deleteCombo(keyproductcombo)"></CircleButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="comb-prod-item-container"
            :class="{'threeGrid' : (combo.productGroupItems.find(p=> p.productImages) || combo.productGroupMax > 1) && !itemsList, 'list': itemsList, 'hideGroup' : hideGroup }">

            <div class="item-comb-prod" v-for="(prod, key) in removeBlockedProds(combo.productGroupItems)" :key="key" :class="{'selected': hasSelected(comboOption, prod)}">
                <template v-if="allowMultipleAdd && combo.productGroupMax > 1">
                    <div v-if="!itemsList" class="image-label-container align-center">
                        <img v-if="prod.subItemProductImages && prod.subItemProductImages.large != null" :src="getImagesURL(prod, 'subItemProductImages', 'large')" alt="">
                        <img v-else-if="useAlternativeLayout" :src="noImageSrc">
                    </div>

                    <QuantityControl
                        :quantity="prod.quantity || 0"
                        :disabledMinus="disabledMinus(prod)"
                        @circleBtnRemove="decreaseAddQtty(prod)"
                        @circleBtnAdd="increaseAddQtty(prod, key)">
                    </QuantityControl>

                    <label class="image-label-container"
                        :for="getCheckboxID(key, prod.subItemCode)"
                        :class="{
                            'disabled-click' : prod.subItemMandatory === 'S' && prod.subItemPreSelected === 'S' && isSelected(key, prod.subItemCode),
                            'expand-width': itemsList,
                            'align-center': !itemsList
                        }">

                        <span class="name" v-text="getProductLanguage(prod, 'subItemName')"></span>
                        <span class="from" v-if="exibApartir() && prod.minPrice && showChildsPrice(combo)">{{ getString('a_partir_de') }}</span>
                        <span class="price full-min-price" v-if="getFullMinPrice(prod, combo)" v-text="formatMoney(getFullMinPrice(prod, combo))"></span>
                        <span class="price" v-if="prod.minPrice && showChildsPrice(combo)" v-text="getProdPrice(prod)"></span>
                        <span class="price" v-if="prod.price && showChildsPrice(combo) && !isFosException(prod, combo)" v-text="getProdPrice(prod)"></span>
                    </label>
                </template>

                <template v-else>
                    <div class="container-input">
                        <input class="styled-input"
                            :id="getCheckboxID(key, prod.subItemCode)"
                            type="checkbox"
                            :class="{'disabled-click' : prod.subItemMandatory === 'S' && prod.subItemPreSelected === 'S' && isSelected(key, prod.subItemCode) }"
                            :value="prod"
                            v-model="comboOption"
                            @change="onProdChoose(prod, $event, key)">

                        <label class="checkmark radio" :for="getCheckboxID(key, prod.subItemCode)"
                            :class="{'disabled-click' : prod.subItemMandatory === 'S' && prod.subItemPreSelected === 'S' && isSelected(key, prod.subItemCode) }">
                        </label>
                    </div>
                    <label class="image-label-container"
                        :for="getCheckboxID(key, prod.subItemCode)"
                        :class="{
                            'disabled-click' : prod.subItemMandatory === 'S' && prod.subItemPreSelected === 'S' && isSelected(key, prod.subItemCode),
                            'expand-width': itemsList
                        }">

                        <template v-if="!itemsList">
                            <img v-if="prod.subItemProductImages && prod.subItemProductImages.large != null" :src="getImagesURL(prod, 'subItemProductImages', 'large')" alt="">
                            <img v-else-if="useAlternativeLayout" :src="noImageSrc">
                        </template>

                        <span class="name" v-text="getProductLanguage(prod, 'subItemName')"></span>
                        <span class="from" v-if="exibApartir() && prod.minPrice && showChildsPrice(combo)">{{ getString('a_partir_de') }}</span>
                        <span class="price full-min-price" v-if="prod.price && showChildsPrice(combo) && !isFosException(prod, combo) && getFullMinPrice(prod, combo)" v-text="formatMoney(getFullMinPrice(prod, combo))"></span>
                        <span class="price" v-if=" prod.minPrice && showChildsPrice(combo)" v-text="getProdPrice(prod)"></span>
                        <span class="price" v-if="prod.price && showChildsPrice(combo) && !isFosException(prod, combo)" v-text="getProdPrice(prod)"></span>
                    </label>
                </template>
            </div>
        </div>

        <div class="overlay" v-if="showModal || showObservationsModal"></div>
        <ModalComboDoCombo
            v-if="showModal"
            :modalData="modalData"
            :depth="depth"
            @modalCancel="modalCancel"
            @modalConfirm="modalConfirm">
        </ModalComboDoCombo>

        <ObservationsModal
            v-if="showObservationsModal"
            :obsModalProd="obsModalProd"
            @obsModalClose="obsModalClose">
        </ObservationsModal>
    </div>
</template>

<script>
/* eslint-disable */
import Util from '@/assets/libs/util'
import QuantityControl from '@/components/QuantityControl'
import ModalComboDoCombo from '@/components/ModalComboDoCombo'
import ObservationsModal from '@/components/ObservationsModal'
import CircleButton from '@/components/CircleButton'
import eventModule from '@/assets/libs/eventModule'
import LocaleController from '@/assets/controllers/LocaleController'
import CartController from '../assets/controllers/CartController'
import DifferentiatedPricesController from '@/assets/controllers/DifferentiatedPricesController'
export default {
    name: 'WizardStep',
    props: ['combo', 'chosen', 'fatherProdCode', 'fatherPrint', 'zindex', 'depth', 'curComboKey', 'mutexData',
        'isEditing', 'blockProds', 'alternativeLayoutCounter'
    ],
    components: {
        QuantityControl,
        ModalComboDoCombo,
        ObservationsModal,
        CircleButton
    },
    data () {
        return {
            allowMultipleAdd: Util.getLocalConfigs('allowMultipleAdd'),
            comboOption: this.chosen || [],
            hideGroup: false,
            disabledTitle: false,
            showModal: false,
            modalData: null,
            obsModalProd: null,
            showObservationsModal: false,
            noImageSrc: null,
            useAlternativeLayout: Util.getLocalConfigs('useAlternativeLayout'),
            itemsList: Util.getLocalConfigs('itemsList'),
            junk: require('../../static/icons/junk-icon.png'),
            edit_white: require('../../static/icons/edit_white.svg'),
            change_white: require('../../static/icons/change_white.svg'),
            delete_white: require('../../static/icons/delete_white.svg'),
            iconesGrandes: Util.getLocalConfigs('iconesGrandes'),
            signalsDiscount: Util.getLocalConfigs('signalsDiscount')
        }
    },
    watch: {
        mutexData: function () {
            if (!this.useAlternativeLayout) {
                let isMutexGroup = this.combo.productGroupMutex && this.mutexData[this.combo.productGroupMutex]
                let hasAnyMutexSelected = this.mutexData[this.combo.productGroupMutex] && this.mutexData[this.combo.productGroupMutex].selectedMutexCode != null
                let isNotSelectedMutex = this.mutexData[this.combo.productGroupMutex] && this.mutexData[this.combo.productGroupMutex].selectedMutexCode !== this.combo.productGroupCode
    
                if (isMutexGroup && hasAnyMutexSelected && isNotSelectedMutex) {
                    this.hideGroup = true
                    this.disabledTitle = true
                } else {
                    this.disabledTitle = false
                }
            }
        }
    },
    created() {
        eventModule.$on('checkNextPreselect', this.checkNextPreselect)
        eventModule.$on('checkHideGroup', this.checkHideGroup)
        eventModule.$on('deleteAllChoices', this.deleteAllChoices)
    },
    beforeDestroy() {
        eventModule.$off('checkNextPreselect', this.checkNextPreselect)
        eventModule.$off('checkHideGroup', this.checkHideGroup)
        eventModule.$off('deleteAllChoices', this.deleteAllChoices)
    },
    mounted () {
        this.noImageSrc = Util.getConfigImage('noImage') ? Util.getConfigImage('noImage') : this.junk
        if (!this.isEditing) {
            this.fillPreselectedProducts(this.combo.productGroupItems, this.combo.productGroupMax)
        }
        this.evaluateHideGroup()
        this.fillCheckboxes()
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        getImagesURL: function (prod, prop, size) {
            return Util.getImagesUrl(prod, prop, size)
            // return Util.getLocalConfigs('urlIMGOdhenInterface')
        },
        getGroupNumber: function () {
            if (this.useAlternativeLayout) {
                return this.alternativeLayoutCounter
            } else {
                return this.depth + 1
            }
        },
        getProdPrice: function (prod) {
            let showMinPriceDifference = Util.getLocalConfigs('showMinPriceDifference')
            let groupHasMinPrice = this.combo && this.combo.minPrice != null
            let diffPrice = DifferentiatedPricesController.getDiffPrice(prod.subItemCode || prod.productCode, true, prod)
            let price = 0
            let groupMin = this.combo && this.combo.productGroupMin > 0
            if (showMinPriceDifference && groupHasMinPrice && groupMin) {
                price = (diffPrice || prod.price) - this.combo.minPrice
            } if (groupHasMinPrice ){
                price = (diffPrice || prod.price || prod.minPrice)                
            } else {
                price = (diffPrice || prod.price)
            }
            return price > 0 ? ` + ${Util.formatMoney(price)}` : ''
        },
        getFullMinPrice: function (prod) {
            let showMinPriceDifference = Util.getLocalConfigs('showMinPriceDifference')
            let groupHasMinPrice = this.combo && this.combo.minPrice != null
            let groupMin = this.combo && this.combo.productGroupMin > 0
            let fullMinPrice = 0
            if (!this.signalsDiscount) {
                return null
            }
            let fullPrice = prod.fullPrice
            let price = prod.price
            if (!fullPrice || fullPrice === 0 || price == 0 || !price || (price + 1) >= fullPrice) {
                return null
            }
            if (showMinPriceDifference && groupHasMinPrice && groupMin) {
                fullMinPrice = prod.fullPrice - this.combo.minPrice
            } else {
                fullMinPrice = prod.fullPrice
            }
            return fullMinPrice
        },
        isSelected: function (key, subItemCode) {
            let id = this.getCheckboxID(key, subItemCode)
            let element = document.getElementById(id)
            return element && element.checked
        },
        checkNextPreselect: function (jumpingToGroupNumber) {
            if (this.depth === jumpingToGroupNumber) {
                if (!this.isEditing) {
                    this.fillPreselectedProducts(this.combo.productGroupItems, this.combo.productGroupMax, jumpingToGroupNumber)
                }
            }
        },
        checkHideGroup: function (groupKey) {
            let hideGroupOnMax = Util.getLocalConfigs('hideGroupOnMax')
            if (hideGroupOnMax && this.depth === groupKey && !this.hideGroup) {
                this.toggleHideGroup()
            }
        },
        deleteAllChoices: function (groupKey) {
            if (this.useAlternativeLayout && this.depth === groupKey) {
                if (this.allowMultipleAdd && this.combo.productGroupMax > 1) {
                    for (let i = this.comboOption.length; i > 0; i--) {
                        let prod = this.comboOption[i - 1]
                        let quantity = prod.quantity || 1

                        for (let i = 0; i < quantity; i++) {
                            this.decreaseAddQtty(prod)
                        }
                    }
                } else if (this.comboOption && this.comboOption.length > 0) {
                    this.comboOption = []
                    this.emitComboOption(this.comboOption, this.depth)
                }
            }
        },
        removeBlockedProds: function (prods) {
            return Util.removeBlockedProds(prods)
        },
        getCheckboxID: function (key, subItemCode) {
            let id = [this.depth, key, subItemCode]
            return id.join('')
        },
        disabledMinus: function (prod) {
            return prod.subItemProductGroups.length > 0 // && prod.quantity > 0
        },
        getArrayFromChoosen: function (choosen) {
            return Util.flatAnObjectList(choosen)
        },
        modalCancel: function (clickedElementId) {
            let clickedElement = document.getElementById(clickedElementId)
            if (clickedElement && clickedElement.checked) clickedElement.checked = false
            this.clearCheckboxes()
            this.fillCheckboxes()
            this.showModal = false
            this.emitComboOption(this.comboOption, this.depth)
        },
        modalConfirm: function (option) {
            if (option.edit) {
                let key = option.key
                this.comboOption.splice(key, 1)
            }

            // O produto que chega em option é uma cópia (deepCopy). Para incrementar o contador de quantidade no front
            // é preciso incrementar a quantidade do produto no array original
            let originalProd = this.combo.productGroupItems[option.prodIndex]
            if (originalProd && originalProd.quantity) {
                if (!option.edit) {
                    originalProd.quantity++
                }
            } else if (originalProd) {
                originalProd.quantity = 1
            }
            this.comboOption.push(option)
            this.emitComboOption(this.comboOption, this.depth)
            this.clearCheckboxes()
            this.fillCheckboxes()
            this.showModal = false
        },
        obsModalClose: function (obsModalProd) {
            // insere o sequence no produto
            CartController.setProductSequence(obsModalProd, false, this.depth + 1, (this.obsModalProd.prodIndex + 1), 0)
            this.comboOption.push(obsModalProd)
            this.emitComboOption(this.comboOption, this.depth)
            this.showObservationsModal = false
        },
        toggleHideGroup: function () {
            if (!this.useAlternativeLayout) {
                let isMutexGroup = this.combo.productGroupMutex && this.mutexData[this.combo.productGroupMutex]
                let hasAnyMutexSelected = this.mutexData[this.combo.productGroupMutex] && this.mutexData[this.combo.productGroupMutex].selectedMutexCode != null
                let isSelectedMutex = this.mutexData[this.combo.productGroupMutex] && this.combo.productGroupCode === this.mutexData[this.combo.productGroupMutex].selectedMutexCode
    
                if (!isMutexGroup || !hasAnyMutexSelected || isSelectedMutex) {
                    this.hideGroup = !this.hideGroup
                }
            }
        },
        evaluateHideGroup: function () {
            if (!this.useAlternativeLayout) {
                let isSingleProdPreselec = this.combo.productGroupItems.length === 1 && this.combo.productGroupItems[0].subItemPreSelected === 'S'
                let isOptionalGroup = this.combo.productGroupMin === 0
                let isMutexGroup = this.combo.productGroupMutex && this.mutexData[this.combo.productGroupMutex]
                let isFirstMutexGroup = isMutexGroup && this.mutexData[this.combo.productGroupMutex].groups[0].productGroupCode === this.combo.productGroupCode
                let hasAnyMutexSelected = this.mutexData[this.combo.productGroupMutex] && this.mutexData[this.combo.productGroupMutex].selectedMutexCode != null
                let isSelectedMutex = this.mutexData[this.combo.productGroupMutex] && this.combo.productGroupCode === this.mutexData[this.combo.productGroupMutex].selectedMutexCode
    
                if (isSingleProdPreselec || isOptionalGroup || isMutexGroup) {
                    this.hideGroup = true
                    if (isMutexGroup && hasAnyMutexSelected && !isSelectedMutex) {
                        this.disabledTitle = true
                    }
                }
    
                if ((isFirstMutexGroup && !hasAnyMutexSelected) || (isMutexGroup && hasAnyMutexSelected && isSelectedMutex)) {
                    this.hideGroup = false
                }
            }
        },
        fillPreselectedProducts: function (productGroupItems, groupMax, depth = 0) {
            let filteredProductGroupItems = Util.removeBlockedProds(productGroupItems)

            filteredProductGroupItems.forEach((product, key) => {
                if (product.subItemPreSelected === 'S' && groupMax === 1 && depth === this.depth) {
                    this.onProdChoose(product, 'preselected', key)
                }
            })
        },
        formatMoney: function (price) {
            return Util.formatMoney(price)
        },
        emitComboOption: function (option, key) {
            this.$emit('comboOption', {'option': option, 'key': key})
        },
        clearCheckboxes: function () {
            if (this.combo.productGroupItems && this.combo.productGroupItems.length > 0) {
                this.combo.productGroupItems.forEach((prod, index) => {

                    let isSelected = this.comboOption.find(element => element.subItemCode === prod.subItemCode)

                    if (!isSelected) {
                        let id = '' + this.depth + index + prod.subItemCode
                        let clickedElement = document.getElementById(id)
                        if (clickedElement && clickedElement.checked) clickedElement.checked = false
                    }
                })
            }
        },
        fillCheckboxes: function () {
            if (this.comboOption && this.comboOption.length > 0) {
                this.comboOption.forEach(option => {
                    let index = (this.combo.productGroupItems || []).findIndex(el => el.subItemCode === option.subItemCode)
                    let id = '' + this.depth + index + option.subItemCode
                    let clickedElement = document.getElementById(id)
                    if (clickedElement && !clickedElement.checked) clickedElement.checked = true
                })
            }
        },
        prepareModal: function (prod, event, prodIndex) {
            this.modalData = prod
            this.modalData.firstLevelFatherPrint = this.fatherPrint
            this.modalData.fatherPrint = this.combo.productGroupPrint
            if (event && event !== 'preselected') {
                let clickedElementId = event.srcElement.id
                this.modalData.clickedElementId = clickedElementId
            }
            if (prodIndex != null) {
                this.modalData.prodIndex = prodIndex
            }
            CartController.setProductSequence(prod, false, this.depth + 1, (prodIndex + 1), 0)
            this.showModal = true
        },
        onProdChoose: function (prod, event, key) {
            let comboDoCombo = Util.isComboDoCombo(prod, this.fatherProdCode)
            let canSelectOnlyOne = this.combo.productGroupMax === 1
            let isChecked = event === 'preselected' ? true : event && event.srcElement.checked
            // let hasObservations = (prod.subItemObservationsChoice || []).length > 0
            let typedObsEnabled = Util.getLocalConfigs('permiteObsDigitada')
            
            let hasObservations = this.hasObservations(prod)
            
            if (comboDoCombo) {
                this.comboOption = this.comboOption.filter(cop => cop !== prod)
                let canSelectMore = this.comboOption.length < this.combo.productGroupMax

                if (canSelectOnlyOne) {
                    this.comboOption = []
                    if ((event && event === 'preselected') || (event && event.srcElement.checked)) {
                        this.prepareModal(prod, event, key)
                    } else {
                        this.emitComboOption(this.comboOption, this.depth) 
                    }
                } else if (canSelectMore && isChecked) {
                    this.prepareModal(prod, event, key)
                } else {
                    event.srcElement.checked = true
                }
            } else if (hasObservations || typedObsEnabled) {
                let canSelectMore = this.comboOption.length <= this.combo.productGroupMax

                if (canSelectOnlyOne) {
                    this.comboOption = []
                    if ((event && event === 'preselected') || prod.subItemMandatory === 'S' || (event && event.srcElement.checked)) {
                        this.obsModalProd = prod
                        this.obsModalProd.prodIndex = key
                        this.showObservationsModal = true
                        this.clearCheckboxes()
                        this.fillCheckboxes()
                    } else {
                        this.emitComboOption(this.comboOption, this.depth)
                    }
                } else if (!canSelectMore) {
                    this.comboOption.pop() 
                    event.srcElement.checked = false
                }else {
                    this.comboOption = []          
                    this.obsModalProd = prod
                    let delay = event === 'preselected' ? 800 : 200
                    setTimeout(() => {
                            this.showObservationsModal = true
                    }, delay)
                }
            } else {
                let canSelectMore = this.comboOption.length <= this.combo.productGroupMax

                if (canSelectOnlyOne) {
                    this.comboOption = []
                    if ((event && event === 'preselected') || prod.subItemMandatory === 'S' || (event && event.srcElement.checked)) {
                        // insere o sequence no produto
                        CartController.setProductSequence(prod, false, this.depth + 1, (key + 1), 0)
                        prod.quantity = 1
                        this.comboOption.push(prod)
                        this.clearCheckboxes()
                        this.fillCheckboxes()
                    } else {
                        this.emitComboOption(this.comboOption, this.depth)
                    }
                } else if (!canSelectMore) {
                    this.comboOption.pop()
                    event.srcElement.checked = false
                }

                this.emitComboOption(this.comboOption, this.depth)
            }
        },

        increaseAddQtty: function (prod, prodIndex) {
            let comboDoCombo = Util.isComboDoCombo(prod, this.fatherProdCode)
            // let hasObservations = (prod.subItemObservationsChoice || []).length > 0
            let typedObsEnabled = Util.getLocalConfigs('permiteObsDigitada')

            let hasObservations = this.hasObservations(prod)

            if (comboDoCombo) {
                let totalGroupItens = 0
                this.comboOption.forEach(option => {
                    if (option.quantity) {
                        totalGroupItens += option.quantity
                    } else{
                        totalGroupItens ++
                    }    
                })
                if(totalGroupItens == this.combo.productGroupMax){
                    Util.showErrorNotification({ title: this.getString('atingiu_limite_categoria'), text: null })
                    return;
                }
                this.prepareModal(prod, null, prodIndex)
            } else {
                let thisProdIndex = this.comboOption.findIndex(element => element.subItemCode === prod.subItemCode)

                if (!prod.quantity) {
                    prod.quantity = 0
                }

                let maxItens = this.combo.productGroupMax
                let totalGroupItens = 0
                this.comboOption.forEach(option => {
                    if (option.quantity) {
                        totalGroupItens += option.quantity
                    } else{
                        totalGroupItens ++
                    }    
                })

                if (totalGroupItens < maxItens) {
                    prod.quantity++
                    this.$forceUpdate()

                    if (thisProdIndex === -1) {
                        if (hasObservations || typedObsEnabled) {
                            this.obsModalProd = prod
                            this.obsModalProd.prodIndex = prodIndex
                            this.showObservationsModal = true
                            return true
                        } else {
                            // insere o sequence no produto
                            CartController.setProductSequence(prod, false, this.depth + 1, (prodIndex + 1), 0)
                            this.comboOption.push(prod)
                        }
                    } else {
                        this.comboOption[thisProdIndex].quantity = prod.quantity
                    }
                    this.emitComboOption(this.comboOption, this.depth)
                } else {
                    Util.showErrorNotification({ title: this.getString('atingiu_limite_categoria'), text: null })
                }
            }
            this.$emit('updateComboPrice')
        },
        decreaseAddQtty: function (prod) {
            let comboDoCombo = Util.isComboDoCombo(prod, this.fatherProdCode)

            if (!comboDoCombo) {
                let thisProdIndex = this.comboOption.findIndex(element => element.subItemCode === prod.subItemCode)
    
                let isMandatory = prod.subItemMandatory === 'S'
                let minProductQuantity = isMandatory ? 1 : 0

                if (prod.quantity && prod.quantity > minProductQuantity) {
                    prod.quantity--
                    this.decreaseReferenceProdQuantity(prod)
                } else if (isMandatory) {
                    Util.showErrorNotification({ title: this.getString('produto_obrigatorio') + ' ' + prod.subItemName, text: null })
                }
                this.$forceUpdate()
    
                if (thisProdIndex !== -1) {
                    this.comboOption[thisProdIndex].quantity = prod.quantity
                    if (this.comboOption[thisProdIndex].quantity === 0) {
                        this.comboOption.splice(thisProdIndex, 1)
                    }
                }
                this.emitComboOption(this.comboOption, this.depth)
            }
        },
        decreaseReferenceProdQuantity: function (prod) {
            if (this.combo.productGroupItems && this.combo.productGroupItems.length > 0) {
                let index = this.combo.productGroupItems.findIndex(element => element.subItemCode === prod.subItemCode)
                if (index !== -1) {
                    this.combo.productGroupItems[index].quantity = prod.quantity
                }
            }
        },
        getCurQnt: function () {
            return this.comboOption.length || this.comboOption.productCode ? 1 : 0
        },
        buildText: function () {
            let text1 = this.getString('escolha')
            let text2 = ''

            if (this.combo.productGroupMin === this.combo.productGroupMax) {
                text2 = this.combo.productGroupMax
            } else {
                text2 = this.getString('ate') + ` ${this.combo.productGroupMax}`
            }

            let text3 = this.combo.productGroupMax === 1 ? this.getString('opcao') : this.getString('opcoes')

            return text1 + text2 + text3
        },
        showChildsPrice: function (comboGroup) {
            if (this.fatherPrint === 'S' && comboGroup.productGroupPrint === 'S') {
                // Se o produto principal (pai) é imprime sim e o grupo promocional também é imprime sim, deve exibir o preço dos filhos
                return true
            } else if (this.fatherPrint === 'N') {
                // Se o produto principal (pai) é imprime não, sempre deve exibir o preço dos itens filhos
                return true
            } else {
                return false
            }
        },
        isFosException: function (product, group) {
            let firstLevelComboPrint = this.fatherPrint === 'S'
            let groupPrint = group && group.productGroupPrint === 'S'
            return Util.isFosException(product, this.fatherProdCode, firstLevelComboPrint, groupPrint)
        },
        editCombo: function (keySelected) {
            let comboSelected = this.comboOption[keySelected]
            comboSelected.edit = true
            comboSelected.key = keySelected
            this.modalData = comboSelected
            this.modalData.fatherPrint = this.combo.productGroupPrint
            this.showModal = true
        },
        deleteCombo: function (keySelected) {
            let clickedElementId = this.comboOption[keySelected].clickedElementId
            let clickedElement = document.getElementById(clickedElementId)
            if (clickedElement && clickedElement.checked) clickedElement.checked = false

            let thisProdIndex = this.comboOption[keySelected].prodIndex
            let originalProd = this.combo.productGroupItems[thisProdIndex]
            if (originalProd && originalProd.quantity && originalProd.quantity > 0) {
                originalProd.quantity--

                let isMutexGroup = this.combo.productGroupMutex && this.mutexData[this.combo.productGroupMutex]
                let hasAnyMutexSelected = this.mutexData[this.combo.productGroupMutex] && this.mutexData[this.combo.productGroupMutex].selectedMutexCode != null
                let isSelectedMutex = this.mutexData[this.combo.productGroupMutex] && this.combo.productGroupCode === this.mutexData[this.combo.productGroupMutex].selectedMutexCode

                if (originalProd.quantity === 0 && isMutexGroup && hasAnyMutexSelected && isSelectedMutex) {
                    this.$emit('clearSelectedMutex', this.mutexData[this.combo.productGroupMutex])
                }
            }

            this.comboOption.splice(keySelected, 1)
            this.$emit('updateComboPrice')
            this.$emit('updateNextButton')
        },
        showChangeMutexButton: function () {
            let isMutexGroup = this.combo.productGroupMutex && this.mutexData[this.combo.productGroupMutex]
            return this.useAlternativeLayout && isMutexGroup
        },
        openSelectMutexModal: function () {
            let mutexKey = this.combo.productGroupMutex
            this.$emit('openSelectMutexModal', mutexKey)
        },
        getProductLanguage: function (product, index) {
            return LocaleController.getIndexLanguages(product, index)
        },
        isAndroidMode: function () {
            return Util.isAndroidMode()
        },
        hasSelected: function (comboOption, prod) {
            if (comboOption.includes(prod)) {
                return true
            }
            return false
        },
        hasObservations: function (prod) {
            if (!Array.isArray(prod.subItemObservationsChoice) || prod.subItemObservationsChoice.length === 0) {
                return false
            }
            return prod.subItemObservationsChoice.some(obs => {
                let filteredObservations = Util.removeBlockedProdsObs(obs.subItemObservations)
                if (filteredObservations.length > 0) {
                    return true
                }
            })
        },
        exibApartir: function () {
            return (Util.exibApartir())
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
    @import (reference) url("../assets/common.less");
    .wizardStep {
        position: relative;
        background: white;
        overflow: auto;
        border-radius: 5px;
        margin-right: 15px;
        margin-bottom: 15px;
        // box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
        border-radius: 5px;

        .hideGroup {
            display: none !important;
        }
        .from {
            text-transform: uppercase;
            font-size: 1rem;
            color: @primary-dark;
            padding-top: 15px;
        }
        .price{
            font-family: @default-font;
            font-size: 2rem;
            color: var(--price-font-color);
            margin: 0;
        }
        .price.full-min-price {
            text-decoration: line-through;
            color: @disabled-color;
            font-size: 1.6rem;
            padding: 0 !important;
        }
        .title-container{
            margin: 20px 0;
            // padding-top: 20px;
            // padding-bottom: 20px;
            display: grid;
            grid-template-columns: 2fr auto;
            justify-content: space-between;
            h2 {
                color: @primary-color;
                vertical-align: middle;
                text-align: left;
                width: calc(100% - 140px);
                padding: 0;
                padding-left: 15px;
                font-size: calc(1vw + 1.9vh);
            }
            .count {
                color: @primary-color;
                font-size: 1.1em;
                margin: auto;
                margin-right: 15px;
            }
            .circle {
                margin-left:30px;
                display:inline-block;
                width: 60px;
                height: 60px;
                border-radius: 50%;
                background-color: @primary-color;
                color:white;
                text-align: center;
                align-items: bottom;
                height: 50px;
                line-height: 50px;
                padding:15px 12px 15px 12px;
            }
            .disabledTitle {
                color: @disabled-color;
            }
            .disabledCircle {
                background-color: @disabled-color;
            }
            .left-part-title {
                display: flex;
                align-items: center;
                padding-right: 30px;
            }
        }
        .img-container{
            height: 450px;
            margin-bottom: 30px;
            img {
                display: block;
                margin: auto;
                max-height: 450px;
            }
        }
        .comb-prod-item-container{
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;
            margin-bottom: 20px;
            // grid-template-columns: 50% 50%;
            overflow: auto;
            max-height: 800px;
            &.threeGrid{
                grid-template-columns: 33.3% 33.3% 33.3%;
                grid-row-gap: 15px;
                .item-comb-prod {
                    flex-direction: column;
                    flex-wrap: nowrap;
                    align-content: center;
                    align-items: center;
                    justify-content: flex-start;
                    margin-top: 0;
                    padding-left: 0;    
                    margin: 15px 0;
                    text-align: center;
                    >div {
                        margin-bottom: 30px; 
                    }
                }
            } &.list {
                // display: grid;
                // grid-template-columns: auto;
                .item-comb-prod {
                    // display: grid;
                    //grid-template-columns: max-content max-content;
                    // text-align: left;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    width: 100%;
                    margin: 0px 30px 30px 30px;
                    padding: 30px 15px;
                    // padding-left: 25px;
                    div {
                        padding-right: 15px;
                    }
                    .image-label-container {
                        width: 100%;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        flex-direction: row;
                    }
                }
            }
            .item-comb-prod {
                display: flex;
                // margin-top: 15px;
                //padding-left: 30px;
                align-items: center;
                grid-template-columns: auto;
                // border: 1px solid @primary-light;
                width: 30%;
                justify-content: center;
                margin: 15px 0;
                padding: 0 0 30px 0;
                box-shadow: 2px 3px 5px 3px rgba(0, 0, 0, 0.1);
                .container-input {
                    display: none;
                }
                .image-label-container {
                    // padding-left: 15px;
                    display: flex;
                    flex-direction: column;
                    height: 100%;
                    justify-content: space-between;
                    // width: 70%;
                    img {
                        // display: block;
                        // margin: auto;
                        max-height: 210px;
                        max-width: 100%;
                        object-fit: contain;
                        overflow: hidden;
                    }
                }
                span {
                    text-align: center;
                    padding-top: 10px;
                }
                .align-center {
                    align-items: center;
                }

                .expand-width {
                    width: 100% !important;
                }
                &.selected {
                    box-shadow: 1px 1px 3px 4px rgba(19, 165, 0, 0.2);
                    background-color: rgba(19, 165, 0, 0.05);
                }
            }
            .item-comb-prod-images{
                text-align: center;
                border-left: 0.8rem solid @white;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: top;
                margin-right: 0;
                color: @black;
                padding-bottom: 20px;
                min-height: 15rem;
                max-height: 27rem;
                background-color: @white;
                margin: 20px;
                box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.1);
                border-radius: 5px;
                margin-left:20px;
                margin-top: 15px;
            }
        }

        .overlay {
            position: fixed;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            background: rgba(0, 0, 0, 0.8);
            z-index: 1;
        }

        .container-input-selected {
            display: grid;
            margin:0px 20px 0px 20px;
            grid-template-columns: 49.5% 49.5%;
            column-gap: 20px;
            padding-bottom:30px;
            .combo-selected {
                border-top:4px solid @primary-light;
                -webkit-box-shadow: 7px 0px 7px rgba(0, 0, 0, 0.1);
                box-shadow: 7px 0px 7px rgba(0, 0, 0, 0.1);
                width: 100%;
                height: 100%;
                position:relative;
                span {
                    display: block;
                }
                .selected-products {
                    padding:20px 10px 10px 20px;
                    .combo-list {
                        padding-left:13px;
                    }
                }
            }
            .card-combo {
                border-bottom: 85px solid @primary-light;
                margin-bottom: 10px;
            }
            .combo-itens {
                font-size:25px;
                color:#524f4f;
            }
            .customize-combo {
                font-weight: bold;
                padding-bottom:7px;
            }
            .edit-button-combo {
                padding-left: 65%;
                position: absolute;
                bottom: -65px;
                display: flex;
                button {
                    margin-left: 15px
                }
            }
            .edit-button-combo.big-mode {
                padding-left: 60%;
                bottom: -74px;
            }
            &.list {
                padding-bottom:0;
            }
        }

        .disabled-click {
            pointer-events: none
        }
    }

    @media (max-width: 698px) { // Gertec SK210
        .wizardStep {
            .title-container{
                margin: 5px 0 0 0;
                padding-top: 5px;
                padding-bottom: 5px;
                .count {
                    font-size: 16px; 
                    margin-right: 10px;
                }
                .circle {
                    margin-left: 10px;
                    width: 18px;
                    height: 18px;
                    line-height: 18px;
                    padding: 12px;
                    font-size: 20px;
                }
            }
            .comb-prod-item-container{
                .item-comb-prod {
                    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
                    font-size: 15px;
                    padding: 0 0 10px 0;
                    .image-label-container {
                        // margin-bottom: 5px;
                        img {
                            // margin-top: 3px;
                            // height: 100px;
                            max-height: 100px;
                        }
                        .name {
                            padding: 5px 3px;
                        }
                        .price {
                            font-size: 15px;
                            padding-top: 3px;
                        }
                        .price.full-min-price {
                            font-size: 13px;
                        }
                    }
                }
                &.threeGrid{
                    .item-comb-prod {
                        >div {
                            margin-bottom: 7px; 
                        }
                    }
                }
                &.list {
                // display: grid;
                // grid-template-columns: auto;
                .item-comb-prod {
                        // display: grid;
                        //grid-template-columns: max-content max-content;
                        // text-align: left;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: center;
                        width: 100%;
                        margin: 10px 10px 10px 15px;
                        padding: 10px 5px;
                        // padding-left: 25px;
                        div {
                            padding-right: 15px;
                        }
                        .image-label-container {
                            width: 100%;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            flex-direction: row;
                        }
                        &.selected {
                            box-shadow: 1px 1px 2px 2px rgba(19, 165, 0, 0.2);
                        }
                    }
                }
            }
            .container-input-selected {  
                margin: 0px 10px 0px 10px;
                padding: 5px 0 5px 0;
                grid-template-columns: 48.5% 48.5%;
                .combo-selected {  
                    .selected-products {
                        padding: 10px 5px 5px 10px;
                        .customize-combo {
                            font-size: 16px;
                        }
                        .combo-list {
                            .combo-itens {
                                font-size: 16px;
                            }
                        }
                    }
                }
                .edit-button-combo {
                    padding-bottom: 30px;
                    padding-left: 35%;
                }
                .card-combo {
                    border-bottom: 45px solid @primary-light;
                    margin-bottom: 10px;
                }
            }
        }
    }

    @media (min-width: 901px) and (max-width: 1025px) { //@tablet
        .wizardStep {
            .price{ 
                font-size: 1.5rem;
            }
            .price.full-min-price {
                font-size: 1.2rem;
            }
            .title-container{
                margin: 15px 0 0 0;
                padding-top: 10px;
                padding-bottom: 10px;
                .count {
                    font-size: 30px; 
                    margin-right: 10px;
                }
                .circle {
                    margin-left: 20px;
                    width: 40px;
                    height: 40px;
                    line-height: 40px;
                    padding: 12px;
                    font-size: 30px;
                }
            }
            .comb-prod-item-container{
                max-height: 600px;
                .item-comb-prod {
                    font-size: 22px;
                    padding: 0 0 15px 0;
                    .image-label-container {
                        margin-bottom: 5px;
                        img {
                            height: 150px;
                        }
                    }
                }
                &.threeGrid{
                    .item-comb-prod {
                        >div {
                            margin-bottom: 20px; 
                        }
                    }
                }
                &.list {
                .item-comb-prod {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: center;
                        width: 100%;
                        margin: 10px 20px 20px 20px;
                        padding: 30px 15px;
                    }
                }
            }

            .container-input-selected {  
                margin: 0px 10px 0px 10px;
                grid-template-columns: 48.5% 48.5%;
                .combo-selected {  
                    .selected-products {
                        .combo-list {
                            .combo-itens {
                                font-size: 20px;
                            }
                        }
                    }
                }
                .edit-button-combo {
                    padding-bottom: 5px;
                    padding-left: 64%;
                }
            }
        }
    }
    @media (min-width: 699px) and (max-width: 900px) {
        .wizardStep {
            .price{ 
                font-size: 1.2rem;
            }
            .price.full-min-price {
                font-size: 1.1rem;
            }
            .title-container{
                margin: 15px 0 0 0;
                padding-top: 10px;
                padding-bottom: 10px;
                .count {
                    font-size: 25px; 
                    margin-right: 10px;
                }
                .circle {
                    margin-left: 20px;
                    width: 30px;
                    height: 30px;
                    line-height: 30px;
                    padding: 12px;
                    font-size: 30px;
                }
            }
            .comb-prod-item-container{
                max-height: 660px;
                // height: 100%;
                .item-comb-prod {
                    font-size: 18px;
                    padding: 0 0 15px 0;
                    width: 28%;
                    .image-label-container {
                        margin-bottom: 5px;
                        img {
                            height: 130px;
                        }
                    }
                }
                &.threeGrid{
                    .item-comb-prod {
                        >div {
                            margin-bottom: 20px; 
                        }
                    }
                }
                &.list {
                .item-comb-prod {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: center;
                        width: 100%;
                        margin: 10px 20px 20px 20px;
                        padding: 30px 15px;
                    }
                }
            }

            .container-input-selected {  
                margin: 0px 10px 0px 10px;
                grid-template-columns: 48.5% 48.5%;
                .combo-selected {  
                    .selected-products {
                        .combo-list {
                            .combo-itens {
                                font-size: 20px;
                            }
                        }
                    }
                }
                .edit-button-combo {
                    padding-bottom: 5px;
                    padding-left: 64%;
                }
            }
        }
    }
    @media (orientation: landscape) {
        .wizardStep {
            margin-right: 0;
            margin-bottom: 0;
            .price{ 
                font-size: 1.8rem;
            }
            .price.full-min-price {
                font-size: 1.6rem;
            }
            .title-container{
                margin: 10px 10px 0 0;
                padding-top: 5px;
                padding-bottom: 10pxpx;
                .count {
                    font-size: 20px; 
                    margin-right: 10px;
                }
                .circle {
                    margin-left: 10px;
                    width: 18px;
                    height: 18px;
                    line-height: 18px;
                    padding: 12px;
                    font-size: 20px;
                }
            }
            .comb-prod-item-container{
                .item-comb-prod {
                    font-size: 18px;
                    padding: 0 0 10px 0;
                    width: 20%;
                    margin: 10px 5px;
                    .image-label-container {
                        // margin-bottom: 5px;
                        height: 100%;
                        justify-content: space-between;
                        img {
                            height: auto;
                            min-height: 130px;
                            max-height: 150px;
                        }
                        .name {
                            padding: 10px 3px;
                        }
                        .price {
                            font-size: 18px;
                        }
                        .price.full-min-price {
                            font-size: 16px;
                        }
                    }
                }
                &.threeGrid{
                    .item-comb-prod {
                        >div {
                            margin-bottom: 7px; 
                        }
                    }
                }
            }

            .container-input-selected {  
                margin: 0px 10px 0px 10px;
                padding: 5px 0 5px 0;
                grid-template-columns: 48.5% 48.5%;
                .combo-selected {  
                    .selected-products {
                        .combo-list {
                            .combo-itens {
                                font-size: 20px;
                            }
                        }
                    }
                }
                .edit-button-combo {
                    padding-bottom: 5px;
                    padding-left: 64%;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/WizardStep.vue